module.exports = __webpack_public_path__ + "img/edit-dark.fe3ad0b8.svg";